import React, { Component } from 'react'
import {VerifyEmailTokenService} from "../../Services/DjangoServices"

export default class CheckEmailVerification extends Component {
        constructor(){
                super();
                this.state = {
                        email_verified: false,
                        got_response: false
                }
        }
        componentDidMount(){
                var url = window.location.href
                var arr = url.split('/')
                var time_token = arr.pop()
                var username = arr.pop()
                var body = { "username_token": username, "time_token": time_token }
                VerifyEmailTokenService(body).then((result) => {
                        result.json().then((data) => {
                                var email_verified = data["email_verified"];
                                if (email_verified) {
                                        this.setState({
                                                got_response: true,
                                                email_verified: true
                                        })
                                }
                                else {
                                        this.setState({
                                                got_response: true,
                                                email_verified: false
                                        })
                                }
                        })
                });
        }
        render() {
                return (
                        <div id="check-email-verification">
                        {
                                this.state.got_response ? 
                                        this.state.email_verified ?
                                                window.location.replace('/workspace')
                                        :
                                                <div align="center">
                                                        <h1>SORRY TOKEN IS INVALID</h1>
                                                </div>
                                :
                                        <div align="center">
                                                <h1>CHECKING EMAIL AND ACTIVATING YOUR ACCOUNT</h1>
                                        </div>
                        }
                        </div>
                )
        }
}
